import { API_PATH } from "@app/common/constants";
import { directoryActions } from "@app/screens/directory-configuration/redux";
import { ToasterService } from "@app/services";
import NetworkService from "@app/services/network/NetworkService";
import { ToastType } from "@app/services/toaster";
import { call, put, takeLatest } from "redux-saga/effects";
import { directoryPageLists } from "@app/screens/directory-configuration/redux/slice";
import {
  getSocialMediaCategoryTypeName,
  socialMediaActions,
  updateSocialmediaListTypeName,
} from "./slice";

/**
 * Update Admin Nav watcher
 */
export function* updateSocialMediaListWatcher() {
  yield takeLatest(updateSocialmediaListTypeName, updateSocialMediaListWorker);
}

/**
 * Update admin nav data
 *
 * @param action
 */
function* updateSocialMediaListWorker(action: any): any {
  const { index, isActive, query } = action.payload;

  yield put(
    directoryActions.updateLoading(
      API_PATH.directoryConfiguration.socialMediaList
    )
  );
  try {
    const response = yield call(
      NetworkService.get,
      API_PATH.directoryConfiguration.socialMediaList,
      { pageIndex: index, pageSize: 15, isActive, name: query || "" },
      {}
    );
    yield put(directoryActions.updateLoading(null));
    if (index === 1) {
      yield put(
        directoryActions.updateTotalRecords({
          listing: directoryPageLists.socialMedia,
          count: response?.data[0]?.totalRecords || 0,
          pageIndex: index,
        })
      );
      yield put(socialMediaActions.fetchSocialMediaList(response?.data));
    } else {
      yield put(
        directoryActions.updateTotalRecords({
          listing: directoryPageLists.socialMedia,
          pageIndex: index,
        })
      );
      yield put(socialMediaActions.fetchSocialMediaNewList(response?.data));
    }
  } catch (error) {
    yield put(directoryActions.updateLoading(null));
    ToasterService.showToaster(
      "Something went wrong while fetching admin data!",
      ToastType.ERROR
    );
  }
}

/**
 * Update Admin Nav watcher
 */
export function* getSocialMediaCategoryWatcher() {
  yield takeLatest(
    getSocialMediaCategoryTypeName,
    getSocialMediaCategoryWorker
  );
}

/**
 * Update admin nav data
 *
 * @param action
 */
function* getSocialMediaCategoryWorker(action: any): any {
  yield put(
    directoryActions.updateLoading(
      API_PATH.directoryConfiguration.getSocialMediaCategory
    )
  );
  try {
    const response = yield call(
      NetworkService.get,
      API_PATH.directoryConfiguration.getSocialMediaCategory,
      {},
      {}
    );
    yield put(directoryActions.updateLoading(null));
    yield put(socialMediaActions.fetchSocialMediaCategory(response.data));
  } catch (error) {
    yield put(directoryActions.updateLoading(null));
    ToasterService.showToaster(
      "Something went wrong while fetching admin data!",
      ToastType.ERROR
    );
  }
}
